import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Box,
    Chip,
    Icon,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { ConstructorViewInfoStatus } from "../../../api/psc";
import { getAccessErrorMessageOrNull } from "../../../constants/SubscriptionConstants";
import { RootState } from "../../../slices/Store";
import ListConstructorVisitedProjectsDialog from "../ListConstructorVisitedProjectsDialog";
import SelectConstructorPhoneNumberDialog from "../SelectConstructorPhoneNumberDialog";

export default function ProjectDetailConstructor(props: {
    visible: boolean;
}) {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    if (
        !props.visible ||
        !projectDetailState.projectDetail?.constructorViewInfo
    ) {
        return <></>;
    }

    // error message for when the status has non-zero value
    const errorMessage = getAccessErrorMessageOrNull(
        projectDetailState.projectDetail?.constructorViewInfo?.status
    );

    const constructorViewInfo =
        projectDetailState.projectDetail.constructorViewInfo;

    return (
        <Box sx={{ mb: 2 }}>
            {errorMessage && (
                <Alert sx={{ mt: 1 }} variant="outlined" severity="error">
                    {errorMessage}
                </Alert>
            )}

            {constructorViewInfo.status ===
                ConstructorViewInfoStatus.NO_ERROR && (
                <Stack spacing={2}>
                    <Paper
                        sx={{
                            px: 2,
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                            flexWap: "wrap",
                        }}
                    >
                        <Typography color="primary" sx={{ flexGrow: "1" }}>
                            {constructorViewInfo.constructor?.name}
                        </Typography>

                        <Stack
                            direction="row"
                            flexWrap="wrap"
                            gap={1}
                            justifyContent="end"
                        >
                            {constructorViewInfo.constructor?.mobileNumbers.map(
                                (pn) => {
                                    return (
                                        <a href={`tel:${pn}`} key={pn}>
                                            <Chip
                                                sx={{ cursor: "pointer" }}
                                                key={pn}
                                                label={
                                                    <Stack
                                                        direction="row"
                                                        spacing={2}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            {pn}
                                                        </Typography>
                                                        <Icon color="primary">
                                                            phone
                                                        </Icon>
                                                    </Stack>
                                                }
                                            />
                                        </a>
                                    );
                                }
                            )}
                        </Stack>
                    </Paper>

                    {constructorViewInfo.status ===
                        ConstructorViewInfoStatus.NO_ERROR && (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<Icon>expand_more</Icon>}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    gap={2}
                                >
                                    <img
                                        width={25}
                                        height={25}
                                        src={"/images/whats_app.png"}
                                    />
                                    <Typography fontSize="small">
                                        ارسال پیام به واتس اپ سازندگان
                                    </Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                                <SelectConstructorPhoneNumberDialog
                                    constructorViewInfo={constructorViewInfo}
                                />
                            </AccordionDetails>
                        </Accordion>
                    )}

                    {constructorViewInfo.hasVisitedProjectsFromSameConstructor && (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<Icon>expand_more</Icon>}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    gap={2}
                                >
                                    <Icon color="secondary">apartment</Icon>
                                    <Typography fontSize="small">
                                        دیگر پروژه های مشاهده شده این سازنده
                                    </Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                                <ListConstructorVisitedProjectsDialog
                                    constructorViewInfo={constructorViewInfo}
                                />
                            </AccordionDetails>
                        </Accordion>
                    )}
                </Stack>
            )}
        </Box>
    );
}
